var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlugverfuegbarkeitenWidget',{attrs:{"flugverfuegbarkeiten":_vm.params.value ?? [],"data":_vm.params.data,"excludeAirports":_vm.params.excludeAirports || []}})
}
var staticRenderFns = []

export { render, staticRenderFns }